var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list" },
    [
      _c("div", { staticClass: "info-div" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "__.Crud.inutilizacaoNotaFiscal.list_vue_html.inutilizacaoNotaFiscal"
              )
            )
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "info-panel" }, [
            _c("span", [_vm._v(_vm._s(_vm.total))]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "__.Crud.inutilizacaoNotaFiscal.list_vue_html.inutilizacaoNotaFiscal"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "__.Crud.inutilizacaoNotaFiscal.list_vue_html.cadastrados"
                  )
                )
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("grid-component", {
        ref: "gridcomponent",
        attrs: {
          data: _vm.gridData,
          tituloPagina: _vm.$t(
            "__.Crud.inutilizacaoNotaFiscal.list_vue_html.inutilizacaoNotaFiscal"
          ),
          columns: _vm.gridColumns,
          showRemoveItem: false,
          "page-index": _vm.pageIndex,
          "page-size": _vm.pageSize,
          total: _vm.total,
        },
        on: {
          "gerar-xls": function ($event) {
            _vm.pags = true
            _vm.tipoDocGerar = 0
          },
          "gerar-pdf": function ($event) {
            _vm.pags = true
            _vm.tipoDocGerar = 1
          },
          "gerar-impressao": function ($event) {
            _vm.pags = true
            _vm.tipoDocGerar = 2
          },
          "change-filter-key": _vm.onChangeFilterKey,
          "change-sort": _vm.onChangeSort,
          "change-page": _vm.onChangePage,
          "edit-item": _vm.onEditItem,
          "create-item": _vm.onCreateItem,
        },
      }),
      _vm._v(" "),
      _c("loading-modal-component", { ref: "loadingModalComponent" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }